import React, { createContext, useContext, useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const SiteSettingsContext = createContext(null);

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    // Defaults while loading
    // [Sprint C8.2 post-C4] Master kill-switch for the club/discounts
    // surface (homepage chips + L2/L3 routes + QR flow). Default true
    // so the feature is visible by default; admin can disable from the
    // Settings panel without a redeploy.
    show_club_section: true,
    show_fuel_section: true,
    show_appliances_section: true,
    show_baby_section: true,
    show_login_button: true,
    require_login: false,
    allow_registration: true,
    allow_google_auth: true,
    show_install_prompt: true,
    baby_hygiene_all_brands_mode: true,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await fetch(`${API_URL}/api/settings`);
      if (res.ok) {
        const data = await res.json();
        setSettings(data);
        setError(null);
      }
    } catch (err) {
      console.error('Failed to fetch site settings:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const refreshSettings = () => {
    fetchSettings();
  };

  return (
    <SiteSettingsContext.Provider value={{ settings, loading, error, refreshSettings }}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export function useSiteSettings() {
  const context = useContext(SiteSettingsContext);
  if (!context) {
    throw new Error('useSiteSettings must be used within SiteSettingsProvider');
  }
  return context;
}

export default SiteSettingsContext;
